import { axios } from "../axios.instance";

export type GetPaymentPlansRequest = object;

export type GetPaymentPlansResponse = Array<{
  id: string;
  price: number;
  category: "plan" | "consumable";
  allowedPaymentSystems: { name: string }[];
  items: {
    itemType: "Plan";
    item: {
      id: string;
      title: string;
      tag: string;
      isOneTime?: boolean;
      duration: {
        months?: number;
        days?: number;
      };
      description: string;
    };
  }[];
}>;

export const getPaymentPlans = async (): Promise<GetPaymentPlansResponse> => {
  const { data } = await axios.get(`/payments/products/plans`);

  return data;
};
